// extracted by mini-css-extract-plugin
module.exports = {"sweetAlert":"ErrorHandler_sweetAlert___dmBI"};